// English strings for the Digital Marketing page (Adyvance Services, owner 2026-10-23): one card per
// ad platform. Spread into `en` as `en.digitalMarketing`. Our own wording.
export const digitalMarketingStrings = {
  soon: "Coming soon",
  overview: {
    title: "Ads overview",
    leadBoth: "Meta and Google ads together. Pick one to see it alone.",
    leadOne: "Your {platform} results. Start the other platform to see them side by side.",
    all: "Both",
    total: "Total",
    daily: "Day by day",
    split: "Meta vs Google",
    goals: "Spend by goal",
    top: "Best ads",
    allTime: "All time",
    noAds: "No ads yet. Promote a product to see it here.",
    open: "Open {platform}",
    kpi: {
      spend: "Spent",
      results: "Results",
      clicks: "Clicks",
      impressions: "Impressions",
      ads: "Live ads: {count}",
    },
    empty: {
      title: "Your ads analytics show here",
      body: "Start Meta Ads or Google Ads and the Adyvance team runs your ads. Spend, results and clicks from every ad appear here, both platforms in one view.",
      points: {
        spend: "Daily spend",
        results: "Results and cost per result",
        clicks: "Clicks and click rate",
        goals: "Best ads and goals",
      },
      start: { meta: "Start Meta Ads", google: "Start Google Ads" },
    },
  },
  cards: {
    meta: {
      title: "Meta",
      body: "Facebook and Instagram ads for your products, run with the Adyvance team.",
    },
    google: {
      title: "Google Ads",
      body: "Search, Shopping and YouTube ads that bring buyers to your store, run with the Adyvance team.",
    },
    tiktok: {
      title: "TikTok Ads",
      body: "Short video ads that put your products in front of TikTok viewers.",
    },
  },
} as const;
